const ItemConstants = {
  TYPES: {
    NOTE: "NOTE",
    TASK: "TASK",
  },
};

module.exports = ItemConstants;
